import React, {useContext} from "react"
import {BuahContext} from "./BuahContext"

const BuahForm = () =>{
  const [buah, setBuah, name, setName, harga, setHarga, berat, setBerat, showForm, setShowForm, statusForm, setStatusForm, currentIndex, setCurrentIndex] = useContext(BuahContext)
  const addNewDataBuah = () => {
      setName("")
      setHarga()
      setBerat()
      setShowForm(true)
      setStatusForm("create")
  }
      
  const handleSubmit = (event) =>{
      event.preventDefault()
      if (currentIndex === -1){
          setBuah([...buah, {nama: name, hargaTotal: harga, beratTotal: berat}])
      } else {
          buah[currentIndex] = {nama: name, hargaTotal: harga, beratTotal: berat}
          setBuah(buah)
      }
      setCurrentIndex(-1)
      setShowForm(false)
      setName("")
      setHarga("")
      setBerat("")
  }

  const handleChangeName = (event) =>{
    setName(event.target.value)
  }
      
  const handleChangeHarga = (event) =>{
    setHarga(event.target.value)
  }

  const handleChangeBerat = (event) =>{
    setBerat(event.target.value)
  }

  return(
    <>
      {!showForm && <button className='button-add' onClick={addNewDataBuah}> Tambah Data Buah</button>}
      {showForm && (
      <>
        <h1 className="App">{statusForm === "create" ? "Tambah Data Buah Baru" : `Edit Data Buah ${name}`}</h1>
        <form className="custom-form" onSubmit={handleSubmit}>
            <div className="custom-input">
            <label htmlFor='name'>Nama:</label>
            <input type="text" value={name} onChange={handleChangeName} />
            <label htmlFor='harga'>Harga Total:</label>
            <input type="number" value={harga} onChange={handleChangeHarga} />
            <label htmlFor='berat'>Berat Total (dalam gram) :</label>
            <input type="number" min="2000" value={berat} onChange={handleChangeBerat} />
            </div>
            <input type="submit" value="Submit"/>
        </form>
      </>
      )}
    </>
  )   
}
    
export default BuahForm